import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import { WHATSAPP_DISPLAY } from '../../../config/site';

export const CONTACT_FAQS = [
  {
    q: 'How fast will someone actually reply?',
    a: 'Under two minutes on average between 9 AM and 11 PM IST, and under 30 seconds for VIP players. Outside those hours you get an immediate acknowledgement and a human reply first thing — payouts themselves never wait, they run 24×7.',
  },
  {
    q: 'Can I get a video call or voice consultation?',
    a: 'Yes. We schedule video consultations for strategy discussions on high-stake games, account reviews, new player onboarding and VIP account management. Message the desk on WhatsApp and pick a time that suits you.',
  },
  {
    q: 'Which languages does the desk speak?',
    a: 'English and Hindi around the clock, with Marathi, Gujarati, Telugu and Punjabi available depending on which specialist is on shift. Write in whichever you are comfortable with.',
  },
  {
    q: 'Is my chat private?',
    a: 'Yes. Conversations stay between you and the desk, we never share numbers with third parties, and we will never ask for your OTP, UPI PIN or full banking password. Anyone who does is not us — report it immediately.',
  },
  {
    q: 'What do I need to open an account?',
    a: 'Just your name, your preferred game and a working WhatsApp number. KYC documents are only needed for higher withdrawal tiers, and the desk walks you through it when the time comes.',
  },
  {
    q: 'Do you help if I want to slow down or take a break?',
    a: 'Always. Ask for deposit limits, loss limits, session timers or full self-exclusion and it is applied the same day, no retention pitch. Counselling support is available 24/7 through the same number.',
  },
];

const ContactFAQ = () => {
  const [open, setOpen] = useState(0);

  return (
    <section className="relative overflow-hidden py-24">
      <span className="aurora right-[-6%] bottom-[8%] h-80 w-80 bg-wa-green/20" aria-hidden="true" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <span className="badge-pill"><Icon name="HelpCircle" size={13} /> Support FAQ</span>
          <h2 className="mt-6 font-heading text-display font-bold text-white">
            Before you <span className="gold-text">message us</span>
          </h2>
          <p className="mt-4 text-body-lg text-white/60">
            The six things players ask the desk most — answered honestly, including the ones about slowing down.
          </p>
        </div>

        <div className="mt-12 space-y-4">
          {CONTACT_FAQS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div
                key={item.q}
                className={`overflow-hidden rounded-2xl border transition-all duration-400 ease-royal ${
                  isOpen
                    ? 'border-wa-green/45 bg-white/[0.06] shadow-[0_24px_50px_-30px_rgba(37,211,102,0.7)]'
                    : 'border-white/8 bg-white/[0.03] hover:border-white/20'
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                >
                  <span className="font-display text-base font-semibold text-white">{item.q}</span>
                  <Icon
                    name="Plus"
                    size={19}
                    className={`shrink-0 text-wa-green transition-transform duration-400 ${isOpen ? 'rotate-45' : ''}`}
                  />
                </button>
                <div className="grid transition-all duration-400 ease-royal" style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}>
                  <div className="overflow-hidden">
                    <p className="px-6 pb-6 text-sm leading-relaxed text-white/60">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-8 text-center text-sm text-white/40">
          Anything else? Message {WHATSAPP_DISPLAY} — someone is awake right now.
        </p>
      </div>
    </section>
  );
};

export default ContactFAQ;
